/*
	The store manages all application data.
	While this data is sourced from our API,
	we may have reason to manipulate it locally in order to...
		initiate a new request
		cleanup and format displays
		sanitize and map server communication
*/

// PRE-Auth
import Vue from 'vue';
import Vuex from 'vuex';
import * as app from '@/qux-common/store/modules/app.js';
import * as notifications from '@/qux-common/store/modules/notifications.js';
import * as account from '@/store/modules/account.js';

// POST-Auth
import * as config from '@/store/modules/config.js';
import * as transaction from '@/store/modules/transaction.js';

Vue.use(Vuex);

// State is simply the local data.
export default new Vuex.Store({
	modules: {
		app,
		account,
		notifications,
		config,
		transaction,
	}
});
